import { render, staticRenderFns } from "./TableTh.vue?vue&type=template&id=180f6b0e&scoped=true"
import script from "./TableTh.vue?vue&type=script&lang=js"
export * from "./TableTh.vue?vue&type=script&lang=js"
import style0 from "./TableTh.vue?vue&type=style&index=0&id=180f6b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f6b0e",
  null
  
)

export default component.exports